import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral([''], ['']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 11px;\n  font-weight: 500;\n'], ['\n  color: ', ';\n  font-size: 11px;\n  font-weight: 500;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  color: #11d596;\n  font-size: 11px;\n  font-weight: 500;\n'], ['\n  color: #11d596;\n  font-size: 11px;\n  font-weight: 500;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: #ff2c71;\n  font-size: 11px;\n  font-weight: 500;\n'], ['\n  color: #ff2c71;\n  font-size: 11px;\n  font-weight: 500;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  margin-left: 12px;\n  color: ', ';\n  font-size: ', ';\n'], ['\n  margin-left: 12px;\n  color: ', ';\n  font-size: ', ';\n']);

import React, { PureComponent } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UserPicture from '../../../../UserPicture';
import { styles, utils, translations } from 'gipsy-misc';

var ReviewersStatus = function (_PureComponent) {
  _inherits(ReviewersStatus, _PureComponent);

  function ReviewersStatus() {
    _classCallCheck(this, ReviewersStatus);

    return _possibleConstructorReturn(this, (ReviewersStatus.__proto__ || Object.getPrototypeOf(ReviewersStatus)).apply(this, arguments));
  }

  _createClass(ReviewersStatus, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Container,
        null,
        this.props.reviewers.map(function (user) {
          return React.createElement(
            Reviewer,
            { key: utils.user.getKey(user), className: 'reviewer' },
            React.createElement(
              Row,
              null,
              React.createElement(UserPicture, { size: 24, src: user.picture }),
              React.createElement(
                UserName,
                null,
                get(user, 'displayName') || get(user, 'email') || '-'
              )
            ),
            React.createElement(
              Row,
              null,
              (!user.reviewStatus || user.reviewStatus === utils.reviewstatus.pending) && React.createElement(
                PendingStatus,
                null,
                translations.review.status.pending.toUpperCase()
              ),
              user.reviewStatus === utils.reviewstatus.reviewed && React.createElement(
                ReviewedStatus,
                null,
                translations.review.status.reviewed.toUpperCase()
              ),
              user.reviewStatus === utils.reviewstatus.reopened && React.createElement(
                ReopenedStatus,
                null,
                translations.review.status.reopened.toUpperCase()
              )
            )
          );
        })
      );
    }
  }]);

  return ReviewersStatus;
}(PureComponent);

ReviewersStatus.propTypes = {
  reviewers: PropTypes.array
};


export default ReviewersStatus;

var Container = styled.div(_templateObject);

var Reviewer = styled.div(_templateObject2);

var Row = styled.div(_templateObject3);

var PendingStatus = styled.span(_templateObject4, styles.colors.darkGrey);

var ReviewedStatus = styled.span(_templateObject5);

var ReopenedStatus = styled.span(_templateObject6);

var UserName = styled.div(_templateObject7, styles.colors.textDarkColor, styles.fonts.fontSizeSmall);
//# sourceMappingURL=ReviewersStatus.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/Review/ReviewersStatus.js
// module id = 311
// module chunks = 0